import api from "./api";

/* LIST ATTENDANCE (paginated, filterable) */
export const getAttendance = async (params = {}) => {
  const response = await api.get("attendance/", { params });
  return response.data;
};

/* GET SINGLE ATTENDANCE */
export const getAttendanceById = async (id) => {
  const response = await api.get(`attendance/${id}/`);
  return response.data;
};

/* CREATE ATTENDANCE */
export const createAttendance = async (data) => {
  const response = await api.post("attendance/", data);
  return response.data;
};

/* UPDATE ATTENDANCE */
export const updateAttendance = async (id, data) => {
  const response = await api.patch(`attendance/${id}/`, data);
  return response.data;
};

/* DELETE ATTENDANCE */
export const deleteAttendance = async (id, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  await api.delete(`attendance/${id}/`, { headers, data: { password }, params: { password } });
};

/* CHECK IN */
export const checkIn = async (data = {}) => {
  const response = await api.post("attendance/check-in/", data);
  return response.data;
};

/* CHECK OUT */
export const checkOut = async (data = {}) => {
  const response = await api.post("attendance/check-out/", data);
  return response.data;
};

export const toggleBreak = async (data = {}) => {
  const response = await api.post("attendance/toggle-break/", data);
  return response.data;
};

/* TODAY STATUS */
export const getTodayStatus = async () => {
  const response = await api.get("attendance/today/");
  return response.data;
};

/* MONTHLY SUMMARY */
export const getMonthlySummary = async (params = {}) => {
  const response = await api.get("attendance/summary/", { params });
  return response.data;
};

/* MONTHLY REPORT */
export const getMonthlyReport = async (params = {}) => {
  const response = await api.get("attendance/monthly-report/", { params });
  return response.data;
};

/* BULK ATTENDANCE */
export const bulkMarkAttendance = async (data) => {
  const response = await api.post("attendance/bulk-mark/", data);
  return response.data;
};

/* EXPORT CSV */
export const exportAttendanceCSV = async (params = {}) => {
  const response = await api.get("attendance/export/", {
    params,
    responseType: "blob",
  });
  return response;
};


/* ── LEAVE REQUESTS ── */
export const getLeaveRequests = async (params = {}) => {
  const response = await api.get("attendance/leave-requests/", { params });
  return response.data;
};

export const createLeaveRequest = async (data) => {
  const response = await api.post("attendance/leave-requests/", data);
  return response.data;
};

export const updateLeaveRequest = async (id, data) => {
  const response = await api.patch(`attendance/leave-requests/${id}/`, data);
  return response.data;
};

export const approveLeaveRequest = async (id, data) => {
  const response = await api.post(`attendance/leave-requests/${id}/approve/`, data);
  return response.data;
};

export const rejectLeaveRequest = async (id, data) => {
  const response = await api.post(`attendance/leave-requests/${id}/reject/`, data);
  return response.data;
};

export const cancelLeaveRequest = async (id, data) => {
  const response = await api.post(`attendance/leave-requests/${id}/cancel/`, data);
  return response.data;
};

/* ── REGULARIZATIONS ── */
export const getRegularizations = async (params = {}) => {
  const response = await api.get("attendance/regularizations/", { params });
  return response.data;
};

export const createRegularization = async (data) => {
  const response = await api.post("attendance/regularizations/", data);
  return response.data;
};

export const approveRegularization = async (id, data) => {
  const response = await api.post(`attendance/regularizations/${id}/approve/`, data);
  return response.data;
};

export const rejectRegularization = async (id, data) => {
  const response = await api.post(`attendance/regularizations/${id}/reject/`, data);
  return response.data;
};
